import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { COLOR_SWATCHES } from '@/constants/site'

interface ColorDotProps {
    color: string
    className?: string
}

const ColorDot: FC<ColorDotProps> = ({ color, className }): ReactNode => {
    const hex = COLOR_SWATCHES[color.trim()]

    if (!hex) return null

    return (
        <span
            aria-hidden='true'
            className={cn('inline-block size-3.5 shrink-0 rounded-full ring-1 ring-foreground/15', className)}
            style={{ backgroundColor: hex }}
        />
    )
}

export default ColorDot
